import { Button, IconText } from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import Select from "react-select";
import useAdditionalExcelUpload from "./useAdditionalExcelUpload";

const AdditionalDocumentUpload = () => {
  const {
    loading,
    formik,
    documentType,
    documentTypeOptions,
    handleClose,
    handleExcelUpload,
    handleDocumentTypeChange,
    getFieldError,
  } = useAdditionalExcelUpload();

  const acceptTypes =
    documentType?.value === 1
      ? ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      : ".pdf, .jpg, .jpeg, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel";

  return (
    <>
      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
          Document Type
        </label>
        <Select
          options={documentTypeOptions}
          value={documentType}
          onChange={handleDocumentTypeChange}
          placeholder="Select document type"
          className={"pro-input lg"}
          classNamePrefix="pro-input"
          menuPlacement="auto"
        />
      </div>
      {documentType && (
        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
            {documentType?.label}
          </label>
          <div className="input-drag">
            <input
              type="file"
              accept={acceptTypes}
              placeholder="placeholder"
              className={`pro-input lg ${
                getFieldError("additional_document") && " error"
              }`}
              id="additional_document"
              onBlur={formik.handleBlur("additional_document")}
              onChange={(e) => handleExcelUpload(e)}
              key={documentType?.value}
            />
            <span className="input-drag-box" style={{ padding: "50px" }}>
              {formik?.values?.additional_document?.name ? (
                formik?.values?.additional_document?.name
              ) : formik?.values?.additional_document ? (
                formik?.values?.additional_document
              ) : (
                <IconText
                  title={
                    documentType?.value === 1
                      ? `Drop Excel/CSV files to attach or browse`
                      : `Drop PDF/Image/Excel files to attach or browse`
                  }
                />
              )}
            </span>
            {getFieldError("additional_document") && (
              <span className="error-text">
                {getFieldError("additional_document")}
              </span>
            )}
          </div>
        </div>
      )}
      <div
        className={`col-12 pro-d-flex pro-justify-end  offcanvas-footer-sticky-btn `}
      >
        <Button className={`pro-btn-link lg pro-px-5 `} onClick={handleClose}>
          Cancel
        </Button>
        <Button
          className={`pro-btn-primary lg pro-ms-3 ${loading && "loading"}`}
          type="submit"
          onClick={formik.handleSubmit}
          disabled={loading || !documentType}
        >
          {"Submit"}
        </Button>
      </div>
    </>
  );
};

export default AdditionalDocumentUpload;
